import { render, staticRenderFns } from "./MSparklesIcon.vue?vue&type=template&id=b30d4898&scoped=true&lang=pug&"
var script = {}
import style0 from "./MSparklesIcon.vue?vue&type=style&index=0&id=b30d4898&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30d4898",
  null
  
)

export default component.exports